import * as z from "zod";
import { userFacingError } from "../authorization";
import { zql } from "../generatedDrizzleSchema";
import { mutator } from "./mutator";

export const resyncSkillSchema = z.object({
  skillId: z.string(),
  connectedAppId: z.string().nullable(),
});

export const SKILL_SYNC_STALE_MS = 15 * 60_000;

export function isSkillSyncInProgress(
  syncStartedAt: number | null,
  now: number
): boolean {
  return syncStartedAt !== null && now - syncStartedAt < SKILL_SYNC_STALE_MS;
}

export const resyncSkill = mutator({
  schema: resyncSkillSchema,
  resolve: {
    skill: { kind: "skill", from: "skillId" },
  },
  permissions: [
    {
      permission: "skill:write",
      scopeId: ({ args }) => args.skill.id,
    },
    {
      permission: "connected_app:use",
      scopeId: ({ args }) => args.connectedAppId,
    },
  ],
  fn: async ({ tx, args: { skill, connectedAppId } }) => {
    const [installation] = await tx.run(
      zql.skillGitInstallations.where("skillId", skill.id).related("source")
    );
    if (!installation?.source) {
      throw userFacingError("Skill is not installed from a Git repository");
    }
    if (installation.source.connectedAppId !== connectedAppId) {
      throw userFacingError("Git connector does not match this skill");
    }
    if (isSkillSyncInProgress(installation.syncStartedAt, Date.now())) {
      throw userFacingError("A resync is already in progress");
    }
    await tx.mutate.skillGitInstallations.update({
      skillId: skill.id,
      syncStartedAt: Date.now(),
      lastError: null,
    });
  },
});
